module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "label-width": "140px"
    }
  }, [_vm._v("        \n        Booking *:\n          "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "placeholder": "ID like '1234567'"
    },
    model: {
      value: (_vm.booking),
      callback: function($$v) {
        _vm.booking = $$v
      },
      expression: "booking"
    }
  }), _vm._v("\n        Departure :\n          "), _c('el-date-picker', {
    staticStyle: {
      "width": "135px"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "placeholder": "Departure date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.departure),
      callback: function($$v) {
        _vm.departure = $$v
      },
      expression: "departure"
    }
  }), _vm._v("\n        Flight :  "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "placeholder": "or1234"
    },
    model: {
      value: (_vm.flightnum),
      callback: function($$v) {
        _vm.flightnum = $$v
      },
      expression: "flightnum"
    }
  }), _vm._v("\n        Traject :\n          "), _c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "placeholder": "Flight info from/to: AMS-MAD"
    },
    model: {
      value: (_vm.traject),
      callback: function($$v) {
        _vm.traject = $$v
      },
      expression: "traject"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.allVersions),
      callback: function($$v) {
        _vm.allVersions = $$v
      },
      expression: "allVersions"
    }
  }, [_vm._v(" AllVersions")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startCheck
    }
  }, [_vm._v("Check Status")]), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), (_vm.result != '') ? _c('el-col', {
    staticStyle: {
      "margin": "10px 0 10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n    Results:\n\t  ")]) : _vm._e(), _vm._v(" "), (_vm.result != '') ? _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dataLoading),
      expression: "dataLoading"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticStyle: {
      "line-height": "1.5em"
    },
    attrs: {
      "type": "textarea",
      "rows": "20"
    },
    model: {
      value: (_vm.result),
      callback: function($$v) {
        _vm.result = $$v
      },
      expression: "result"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-644d1d20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dbc/dbccheck.vue
// module id = 646
// module chunks = 1